const API_BASE_URL = process.env.REACT_APP_API_ADDRESS;

const parseResponse = async (response) => {
  const contentType = response.headers.get('content-type') || '';

  // JSON: normal path
  if (contentType.includes('application/json')) {
    return await response.json();
  }

  // Non-JSON (HTML/text)
  const text = await response.text();

  // If backend returned HTML error page, don't leak it into UI
  const looksLikeHtml = /<!doctype html>|<html[\s>]/i.test(text);

  if (!response.ok) {
    // keep raw in dev console if you want
    if (looksLikeHtml) {
      console.error('Non-JSON backend error (HTML):', text);
      return { detail: 'Server error. Please try again later.' };
    }

    // plaintext error
    return { detail: text || 'Request failed' };
  }

  // OK but non-json (rare)
  return { detail: text };
};

const authHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
});

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
});

// === Admin: Bulk create universal registration codes ===
// ViewSet action name: create_bulk
export const createUniversalRegCodesBulk = async ({
  items,
  default_send_email = false,
} = {}) => {
  try {
    const url = `${API_BASE_URL}/accounts/universal-reg-codes/create_bulk/`;

    const response = await fetch(url, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ items, default_send_email }),
    });

    const data = await parseResponse(response);

    return {
      success: response.ok,
      data: response.ok ? data : null,
      error: response.ok ? null : data.error || data.detail || 'Request failed',
      statusCode: response.status,
    };
  } catch (error) {
    console.error('createUniversalRegCodesBulk error', error);
    return { success: false, data: null, error: error.message, statusCode: 500 };
  }
};

// === Public: Resolve code (prefill + click count increment) ===
// ViewSet action name: resolve
export const resolveUniversalRegCode = async ({ code } = {}) => {
  try {
    const url = `${API_BASE_URL}/accounts/universal-reg-codes/resolve/`;

    const response = await fetch(url, {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ code }),
    });

    const data = await parseResponse(response);

    return {
      success: response.ok,
      data: response.ok ? data : null,
      error: response.ok ? null : data.error || data.detail || 'Request failed',
      statusCode: response.status,
    };
  } catch (error) {
    console.error('resolveUniversalRegCode error', error);
    return { success: false, data: null, error: error.message, statusCode: 500 };
  }
};

// === Public: Register via universal code ===
// ViewSet action name: register
export const registerViaUniversalRegCode = async ({
  code,
  username,
  password,
} = {}) => {
  try {
    const url = `${API_BASE_URL}/accounts/universal-reg-codes/register/`;

    const response = await fetch(url, {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ code, username, password }),
    });

    const data = await parseResponse(response);

    return {
      success: response.ok,
      data: response.ok ? data : null,
      error: response.ok ? null : data.error || data.detail || 'Request failed',
      statusCode: response.status,
    };
  } catch (error) {
    console.error('registerViaUniversalRegCode error', error);
    return { success: false, data: null, error: error.message, statusCode: 500 };
  }
};
